<template>
  <a-form id="policy-form" class="flex-grow-1 d-flex flex-column overflow-y-hidden" :form="policyForm" @submit="onSubmit">
    <div class="p-20-px flex-grow-1 overflow-y-auto">
      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-item label="Policy Name" class="name">
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input Policy Name!'
                    }
                  ]
                }
              ]"
              placeholder="Policy Name"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="Policy Description" class="description">
            <a-input
              v-decorator="[
                'description',
                {
                  rules: [
                    {
                      max: 100,
                      message: 'Description have to less than 100 characters!'
                    },
                    {
                      required: true,
                      message: 'Please input Policy Description!'
                    }
                  ]
                }
              ]"
              placeholder="Description"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <div class="rule-list">
            <div>
              <div class="ant-form-item-label">
                <label>Rule List</label>
              </div>
              <a-button class="a-header--button btn-secondary" type="primary" @click="onAddRule">
                <img class="mr-2 icon-size" src="@assets/icon/plus.svg">
                Add New Rule
              </a-button>
            </div>
            <table class="full-w mt-4">
              <thead>
                <tr>
                  <th class="w-50">
                    No.
                  </th>
                  <th class="w-300">
                    Element
                  </th>
                  <th class="w-200">
                    Condition
                  </th>
                  <th>Keyword</th>
                  <th class="w-200">
                    Action
                  </th>
                  <th class="w-50" />
                </tr>
              </thead>
              <tbody>
                <tr v-for="k in policyForm.getFieldValue('keys')" :key="k">
                  <td>
                    <!-- Start form hide -->
                    <a-form-item class="mt-3 hide">
                      <a-input v-decorator="[`rules[${k}].severity`]" />
                    </a-form-item>
                    <!-- End form hide -->
                    {{ policyForm.getFieldValue(`rules[${k}].severity`) }}
                  </td>
                  <td>
                    <a-form-item class="mt-3">
                      <a-select
                        v-decorator="[
                          `rules[${k}].type`,
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Type!'
                              }
                            ]
                          }
                        ]"
                        size="large"
                      >
                        <a-select-option v-for="type in ruleTypes" :key="type.id" :value="type.id">
                          {{ type.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </td>
                  <td>
                    <a-form-item class="mt-3">
                      <a-select
                        v-decorator="[
                          `rules[${k}].condition`,
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Condition!'
                              }
                            ]
                          }
                        ]"
                        size="large"
                      >
                        <a-select-option v-for="condition in conditions" :key="condition.id" :value="condition.id">
                          {{ condition.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </td>
                  <td>
                    <div>
                      <a-form-item class="mt-3">
                        <a-input
                          v-decorator="[
                            `rules[${k}].field`,
                            {
                              rules: [
                                {
                                  required: true,
                                  message: 'Please input Description'
                                }
                              ]
                            }
                          ]"
                          placeholder="Description"
                        />
                      </a-form-item>
                    </div>
                  </td>
                  <td>
                    <a-form-item class="mt-3">
                      <a-select
                        v-decorator="[
                          `rules[${k}].action`,
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Condition!'
                              }
                            ]
                          }
                        ]"
                        size="large"
                      >
                        <a-select-option v-for="action in actions" :key="action.id" :value="action.id">
                          {{ action.name }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </td>
                  <td>
                    <a-button size="large" class="remove-btn" @click="onRemoveRule(k)">
                      <img src="@assets/icon/remove.svg">
                    </a-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </a-col>
      </a-row>
      <div class="ant-form-item-label">
        <label>Full Page HTML (Keyword Monitoring)</label>
      </div>
      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-item>
            <template slot="label">
              Blacklisted keyword(s)
              <a-tooltip placement="top">
                <template slot="title">
                  <span class="fs-10">
                    Specifies what keyword(s) that we should not appear on your webpage <br>Examples: mysql/php error
                  </span>
                </template>
                <a-icon type="info-circle" theme="filled" />
              </a-tooltip>
            </template>
            <a-checkbox :checked="isUsingGenericBlacklistKeywords" @change="toggleGenericBlacklistKeywords">
              Enable generic blacklist keyword dictionary
            </a-checkbox>
            <a-textarea v-decorator="['text_string_not_appear']" class="row-6 mb-0" :rows="6" @change="setGenericBlacklistKeywordsToggle" />
            <span class="fs-10">
              Separate different keywords by a comma (,). Keywords are case-insensitive.
            </span>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template slot="label">
              Whitelisted keyword(s)
              <a-tooltip placement="top">
                <template slot="title">
                  <span class="fs-10">
                    Specifies what keyword(s) that we should monitor on your webpage <br>Examples: company name, webpage title
                  </span>
                </template>
                <a-icon type="info-circle" theme="filled" />
              </a-tooltip>
            </template>
            <br>
            <a-textarea v-decorator="['text_string_appear']" class="row-6 mb-0" :rows="6" />
            <div class="fs-10">
              Separate different keywords by a comma (,). Keywords are case-insensitive.
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-divider />
      <div id="sih" class="ant-form-item-label">
        <label>Smart Image Hash (Integrity Monitoring)</label>
      </div>
      <a-row class="smart-image-hash" style="margin-top:20px; margin-bottom: 12px;">
        <a-col :span="7" style="text-align: center; height: 76px; vertical-align: middle; display: table">
          <div style="display: table-cell; vertical-align: middle">
            <a-switch
              :checked="policyForm.getFieldValue('sih_is_slider_enable')" 
              @click="()=>{
                policyForm.setFieldsValue({
                  'sih_is_slider_enable': !policyForm.getFieldValue('sih_is_slider_enable')
                })}"
            >
              <a-icon slot="checkedChildren" type="check" />
              <a-icon slot="unCheckedChildren" type="close" />
            </a-switch>
            <div style="font-weight: 600; font-size: 1.25em">
              Smart Image Hash
            </div>
            <div>Identify image differences smartly and reduce the number of wrong alerts of image caused by image compression and so on.</div>
          </div>
        </a-col>
        <a-col :span="1" style="margin-top: 16px; height: 84px; text-align: center">
          <a-divider type="vertical" style="height: 100%" />
        </a-col>
        <a-col :span="16" style="margin-top: 8px" :class="{grayscale: !policyForm.getFieldValue('sih_is_slider_enable')}">
          <div class="slider_title">
            Alert Threshold Settings
            <a-tooltip placement="right">
              <template slot="title" style="background-color: #d9edff">
                The higher threshold, the larger the difference between images is required to 
                trigger alerts. Hence, the thresholds in 
                <span style="color: red; font-weight: 700">
                  red
                </span> may not be recommended as you may miss out on true alerts. 
                <br><b>The recommended value is 10</b>.
              </template>
              <a-icon class="explain" type="info-circle" theme="filled" />
            </a-tooltip>
          </div>
          <a-slider
            :key="sih_slider_render_key"
            :defaultValue="policyForm.getFieldValue('sih_slider_value')"
            :min="1"
            :max="100"
            :marks="sih_slider_marks"
            :disabled="!policyForm.getFieldValue('sih_is_slider_enable')" 
            @afterChange="(value)=>{
              policyForm.setFieldsValue({
                'sih_slider_value': value,
              })
            }"
          />
        </a-col>
      </a-row>

      <a-divider />

      <a-row>
        <a-card title="NLP Engine Settings">
          <a-checkbox 
            :checked="policyForm.getFieldValue('nlp_enabled') && showNLPEngine"
            :disabled="!showNLPEngine"
            style="font-size: 15px"
            @change="change_enable_nlp_deeplearning_engine"
            @click.stop
            @change.stop
          >
            Enable AI NLP Engine
          </a-checkbox>
          <p v-if="!showNLPEngine">
            You are currently not subscribed to this engine. Please contact us at
            <a href="mailto://sales@cloudsine.tech">
              sales@cloudsine.tech
            </a> 
            to begin your subscription. 
          </p>
          <a-divider />

          <div v-if="policyForm.getFieldValue('distilbert_model').enabled">
            <p style="font-size: 15px; font-weight:bolder">
              Model T Configurations:
            </p>
            <NLPComponent
              :model="policyForm.getFieldValue('distilbert_model')"
              style="margin-left: 12px"
              @change="(value)=>{
                policyForm.setFieldsValue({'distilbert_model': value})
              }"
            />
          </div>
          
          <a-collapse expand-icon-position="left" style="margin-top: 10px" :v-if="policyForm.getFieldValue('nlp_enabled')">
            <a-collapse-panel key="xgboost" header="Advanced Settings">
              <a-alert
                message="Alert policy"
                type="warning"
                style="margin-bottom: 10px"
              >
                <p slot="description">
                  Enable alert triggers based on
                  <a-select :key="nlp_notification_render_key" v-model="policyForm.getFieldValue('notifyWhen')" style="width: 240px" :disabled="!policyForm.getFieldValue('nlp_enabled')" @change="update_nlp_notification_policy">
                    <a-select-option value="DistilBERT+">
                      Model T only
                    </a-select-option>
                    <a-select-option value="Either">
                      Either Model T or Model X
                    </a-select-option>
                    <a-select-option value="Both">
                      Both Model T and Model X
                    </a-select-option>
                    <a-select-option value="XGB">
                      Model X only
                    </a-select-option>
                  </a-select>
                </p>
              </a-alert> 
              <div v-if="policyForm.getFieldValue('xgboost_model').enabled">
                <p style="font-size: 15px; font-weight:bolder">
                  Model X Configurations:
                </p>
                <NLPComponent
                  :model="policyForm.getFieldValue('xgboost_model')"
                  style="margin-left: 12px"
                  @change="(value)=>{
                    policyForm.setFieldsValue({'xgboost_model': value})
                  }"
                />
              </div>
            </a-collapse-panel>
          </a-collapse>
        </a-card>
      </a-row>
      <a-divider />
      <a-row :gutter="20">
        <a-col :span="24">
          <transfer :mockData="urls" showSearch :selectedItem="policy.url_ids || []" :titles="['Select URL(s) for this Policy', 'Selected URL(s)']" :keyFilter="`title`" @change="onChangeURLs($event)" />
        </a-col>
      </a-row>
    </div>
    <div class="a-footer">
      <a-button key="back" size="large" class="mr-3 slide-down-enter-active" @click="onCancel()">
        Cancel
      </a-button>
      <a-button key="submit" size="large" type="primary" html-type="submit" class="slide-down-enter-active">
        Save
      </a-button>
    </div>
  </a-form>
</template>

<script>
  import { RULE_TYPES, RULE_ACTIONS, RULE_CONDITIONS } from '@constants/rules';
  import { getMinusSiblingsHeight } from '@shared/helpers/utils';
  import PolicyService from '../services/policy.service';
  import {debounce} from "lodash";
  import NLPComponent from "./NLPComponent.vue";
  import ApiService from '@shared/services/api.service';
  
  export default {
    name: 'PolicyForm',
    components: {
    NLPComponent
},
    props: {
      policy: {
        name: String,
        description: String,
        text_string_appear: String,
        text_string_not_appear: String,
        smart_image_hash_configurations: {},
        distilbert_model: {},
        xgboost_model: {},
        notifyWhen: String,
        nlp_enabled: Boolean,
        rules: [
          {
            type: String,
            action: String,
            condition: String,
            field: String,
            severity: Number
          }
        ],
        url_ids: Array
      }
    },
    data() {
      return {
        policyId: +this.$route.params.policy,
        actions: RULE_ACTIONS,
        ruleTypes: RULE_TYPES,
        conditions: RULE_CONDITIONS,
        urls: [],
        isUsingGenericBlacklistKeywords: false,
        genericBlacklistKeywords: [
          "hack", "hacker", "hacked", "hacking", "h4ck", "hackeado", "deface", "defacement", "d3f4c3", "vandalise", "Vandalism", "vandalize", "v4nd4lis3", "exploit", "exploited", "Black Hat", "Hacker Team", "Pwned", "Pawned", "Anonymous", "Xploit"
        ],
        // NLP Engine
        showNLPEngine: false,
        nlp_notification_render_key : 0,
        // sih
        sih_slider_render_key: 0,
        sih_slider_marks: {
          5: {
            label: (
              <span style="color: black;">Small<br />Difference</span>
            ),
          },
          10: {
            label: (
              <a-tooltip placement="right">
                <template slot="title">Recommended alert threshold value</template>
                <a-icon type="like" style="color: green;" rotate={350} />
              </a-tooltip>
            ),
          },
          20: {
            label: <span style="color: black;">Medium</span>
          },
          48: {
            label: (
              <a-tooltip placement="right">
                <template slot="title">Not recommended</template>
                <span style="color: black;">High</span>
              </a-tooltip>
            ),
          },
          76: {
            label: (
              <a-tooltip placement="right">
                <template slot="title">Not recommended</template>
                <span style="color: black;">Very High</span>
              </a-tooltip>
            ),
          },
          95: {
            style: {
              width: "100px"
            },
            label: (
              <a-tooltip placement="right">
                <template slot="title">Not recommended</template>
                <span style="color: black;">Extremely High<br/>Difference</span>
              </a-tooltip>
            ),
          },
        },
      };
    },
    computed: {
      isShowSMSNotification() {
        return Boolean(this.$store.state.user.data.rbac && this.$store.state.user.data.rbac.length > 0 && this.$store.state.user.data.rbac[0]);
      },
      featureAccess() {
        return this.$store.state.user.data.feature_access;
      },
    },
    watch: {
      policy: {
        immediate: true,
        handler(newVal, oldVal) {
          if (newVal !== oldVal) {
            this.setPolicyForm();
            this.sih_slider_render_key++;
          }
        }
      }
    },
    beforeCreate() {
      this.policyForm = this.$form.createForm(this, {
        name: 'policy-form'
      });
      this.policyForm.getFieldDecorator('keys', {
        initialValue: [],
        preserve: true
      });

      this.policyForm.getFieldDecorator('url_ids', {
        initialValue: [],
        preserve: true
      });

      // smart image hash
      this.policyForm.getFieldDecorator('sih_is_slider_enable', {
        initialValue: false,
        preserve: true
      });
      this.policyForm.getFieldDecorator('sih_slider_value', {
        initialValue: 10,
        preserve: true
      });

      this.policyForm.getFieldDecorator('distilbert_model', {
        initialValue: {
          model_name: "distilbert",
          enabled: false,
          defaced_threshold: 0.5,
          words_ignored: [],
        },
        preserve: true
      });

      this.policyForm.getFieldDecorator('xgboost_model', {
        initialValue: {
          model_name: "xgboost",
          enabled: false,
          defaced_threshold: 0.5,
          words_ignored: [],
        },
        preserve: true
      });

      this.policyForm.getFieldDecorator('notifyWhen', {
        initialValue: 'DistilBERT+',
        preserve: true
      });

      this.policyForm.getFieldDecorator('nlp_enabled', {
        initialValue: false,
        preserve: true
      });
    },
    async mounted() {
      this.getUrls();
      await this.check_nlp_subscription();
      if (this.$refs.bodyElement) {
        this.$refs.bodyElement.style.height = `calc(100% - ${getMinusSiblingsHeight(this.$refs.bodyElement)})`;
      }
      // scroll to anchor position
      if (this.$route.hash != "") {
        const el = document.querySelector(this.$route.hash);
        el && el.scrollIntoView();
      }
    },
    updated() {
      if (this.$refs.bodyElement) {
        this.$refs.bodyElement.style.height = `calc(100% - ${getMinusSiblingsHeight(this.$refs.bodyElement)})`;
      }
    },
    methods: {
      async check_nlp_subscription(){
        const isNLPEngineSubscribed = !!this.featureAccess['nlp-engine'];
        if (isNLPEngineSubscribed){
          this.showNLPEngine = true;
          return;
        }
        this.getNLPTrail();
      },
      async getNLPTrail() {
      ApiService.get('trial_features/nlp_engine').then(res=>{
        if (res){
          this.isEngineTrial = true;
          this.trialEndDate = new Date(res.end_date);
          const trial_valid = this.trialEndDate > new Date();
          if (trial_valid){
            this.showNLPEngine = true;
          }
        }
      }).catch(error=>{
        this.$showMultiErrorMessage(error.messages);
      });
    },
      change_enable_nlp_deeplearning_engine(){
        this.policyForm.setFieldsValue({'nlp_enabled': !this.policyForm.getFieldValue('nlp_enabled')})
        if (this.policyForm.getFieldValue('nlp_enabled')){
          const distilbert_model = this.policyForm.getFieldValue('distilbert_model');
          distilbert_model.enabled = true;
          this.policyForm.setFieldsValue({'distilbert_model': distilbert_model});

          const xgboost_model = this.policyForm.getFieldValue('xgboost_model');
          xgboost_model.enabled = false;
          this.policyForm.setFieldsValue({'xgboost_model': xgboost_model});

          this.policyForm.setFieldsValue({'notifyWhen': 'DistilBERT+'});
        } else {
          const distilbert_model = this.policyForm.getFieldValue('distilbert_model');
          distilbert_model.enabled = false;
          this.policyForm.setFieldsValue({'distilbert_model': distilbert_model});

          const xgboost_model = this.policyForm.getFieldValue('xgboost_model');
          xgboost_model.enabled = false;
          this.policyForm.setFieldsValue({'xgboost_model': xgboost_model});
          
          this.policyForm.setFieldsValue({'notifyWhen': 'DistilBERT+'});
        }
        this.nlp_notification_render_key++;
      },
      update_nlp_notification_policy(selection){
        const distilbert_model = this.policyForm.getFieldValue('distilbert_model');
        const xgboost_model = this.policyForm.getFieldValue('xgboost_model');
        switch (selection){
          case "Either":
            distilbert_model.enabled = true;
            xgboost_model.enabled = true;
            break;
          case "Both":
            distilbert_model.enabled = true;
            xgboost_model.enabled = true
            break 
          case "DistilBERT+":
            distilbert_model.enabled = true;
            xgboost_model.enabled = false;
            break
          case "XGB":
            distilbert_model.enabled = false;
            xgboost_model.enabled = true;
            break
          default:
            distilbert_model.enabled = true;
            xgboost_model.enabled = true;
            break
        }
        this.policyForm.setFieldsValue({'distilbert_model': distilbert_model});
        this.policyForm.setFieldsValue({'xgboost_model': xgboost_model});
        this.policyForm.setFieldsValue({'notifyWhen': selection});
      },
      onSubmit(e) {
        e.preventDefault();
        this.policyForm.validateFields((err, values) => {
          values.rules = this._.compact(values.rules);
          if (!err) {
            this.$emit('submit', values);
          }
        });
      },
      onCancel() {
        this.$router.push('/policy/list');
      },
      setPolicyForm() {
        this.policyForm.setFieldsValue({
          name: this.policy.name,
          description: this.policy.description,
          text_string_appear: this.policy.text_string_appear,
          text_string_not_appear: this.policy.text_string_not_appear,
          url_ids: this.policy.url_ids,

          // smart image hash config
          sih_is_slider_enable: this.policy.smart_image_hash_configurations?this.policy.smart_image_hash_configurations.imgHashEnable===1:false,
          sih_slider_value: this.policy.smart_image_hash_configurations?this.policy.smart_image_hash_configurations.imgHashSensitivity:10,
          notifyWhen: this.policy.notifyWhen? this.policy.notifyWhen:'DistilBERT+',
          nlp_enabled: this.policy.nlp_enabled ? this.policy.nlp_enabled : false,
          distilbert_model: this.policy.distilbert_model ? this.policy.distilbert_model : {
            model_name: "distilbert",
            enabled: false,
            defaced_threshold: 0.5,
            words_ignored: [],
          },
          xgboost_model: this.policy.xgboost_model ? this.policy.xgboost_model : {
            model_name: "xgboost",
            enabled: false,
            defaced_threshold: 0.5,
            words_ignored: [],
          },
          keys: (this.policy.rules || []).map((item, index) => {
            this.setValueRules(index, item);
            return index;
          })
        });
        this.setValueSeverity();
        this.setGenericBlacklistKeywordsToggle();
      },
      setValueRules(k, data) {
        this.policyForm.getFieldDecorator(`rules[${k}].type`, {
          initialValue: data.type
        });
        this.policyForm.getFieldDecorator(`rules[${k}].condition`, {
          initialValue: data.condition
        });
        this.policyForm.getFieldDecorator(`rules[${k}].field`, {
          initialValue: data.field
        });
        this.policyForm.getFieldDecorator(`rules[${k}].action`, {
          initialValue: data.action
        });
      },
      onAddRule() {
        const keys = this.policyForm.getFieldValue('keys');
        let nextKey = this._.max(keys) || 0;
        const nextKeys = keys.concat(++nextKey);

        this.policyForm.setFieldsValue({
          keys: nextKeys
        });
        const newRule = {
          type: 'HREF',
          action: 'Do not monitor',
          condition: 'Contains',
          field: ''
        };
        this.setValueRules(nextKey, newRule);
        this.setValueSeverity();
      },
      onRemoveRule(k) {
        const keys = this.policyForm.getFieldValue('keys');
        if (keys.length === 1) {
          return;
        }

        this.policyForm.setFieldsValue({
          keys: keys.filter((key) => key !== k)
        });
        this.setValueSeverity();
      },
      setValueSeverity() {
        this.policyForm.getFieldValue('keys').forEach((k, index) => {
          this.policyForm.getFieldDecorator(`rules[${k}].severity`, {
            initialValue: (index + 1) * 10
          });
        });
      },
      onChangeURLs(event) {
        this.policy.url_ids = event;
        this.policyForm.setFieldsValue({
          url_ids: this.policy.url_ids
        });
      },
      async getUrls() {
        try {
          const response = await PolicyService.getList();
          const url_ids = [];
          response.forEach((item) => {
            if (item.id != this.policyId) {
              url_ids.push(...item.url_ids);
            }
          });
          const data = await PolicyService.getUrlList();
          this.urls = (data || [])
            .filter((item) => !url_ids.includes(item.id))
            .map((item) => {
              return {
                key: item.id.toString(),
                title: item.url,
                disabled: false
              };
            });
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        }
      },
      toggleGenericBlacklistKeywords() {
        if (this.isUsingGenericBlacklistKeywords) {
          this.removeGenericBlacklistKeywords();
        } else {
          this.addGenericBlacklistKeywords();
        }
      },
      setGenericBlacklistKeywordsToggle: debounce(function(event) {

        console.log("toggle triggered 1");

        this.$nextTick(() => this.$nextTick(() => {

          let currentWords = this.policyForm.getFieldValue('text_string_not_appear');
          currentWords = currentWords.split(',');
          currentWords = currentWords.map((a) => a.trim());

          console.log("toggle triggered 2", currentWords);

          let hasAllWords = true;

          const newWordsToAdd = this.genericBlacklistKeywords;
          console.log(newWordsToAdd);
          for (let i = 0; i < newWordsToAdd.length; i++) {
            let alreadyHasWord = false;
            for (let j = 0; j < currentWords.length; j++) {
              if (newWordsToAdd[i].trim().toLowerCase() == currentWords[j].trim().toLowerCase()) {
                alreadyHasWord = true;
                break;
              }
            }
            if (!alreadyHasWord) {
              hasAllWords = false;
            }
          }

          if (hasAllWords) {
            this.isUsingGenericBlacklistKeywords = true;
          } else {
            this.isUsingGenericBlacklistKeywords = false;
          }

        }));
      }, 500, {leading: true}),
      addGenericBlacklistKeywords() {
        let currentWords = this.policyForm.getFieldValue('text_string_not_appear');
        let wordsToBlacklist;
        
        if (currentWords) {
          currentWords = currentWords.split(',').map((a) => a.trim());
          const currentWordsInLowerCase = currentWords.map((word) => word.toLowerCase());
          const wordsToAdd = this.genericBlacklistKeywords.filter((word) => !currentWordsInLowerCase.includes(word.toLowerCase()));
          wordsToBlacklist = [...currentWords, ...wordsToAdd];
        } else {
          wordsToBlacklist = this.genericBlacklistKeywords;
        }

        this.policyForm.setFieldsValue({
          'text_string_not_appear': wordsToBlacklist.join(", ")
        });

        this.setGenericBlacklistKeywordsToggle();
      },
      removeGenericBlacklistKeywords() {
        let currentWords = this.policyForm.getFieldValue('text_string_not_appear');
        currentWords = currentWords.split(',');
        currentWords = currentWords.map((a) => a.trim());

        let newWords = currentWords.filter((currentWord) => {
          const newWordsToAdd = this.genericBlacklistKeywords;
          for (let i = 0; i < newWordsToAdd.length; i++) {
            if (newWordsToAdd[i].trim().toLowerCase() == currentWord.trim().toLowerCase()) {
              return false;
            }
          }
          return true;
        });

        newWords = newWords.filter((a) => a.trim());

        this.policyForm.setFieldsValue({
          'text_string_not_appear': newWords.join(", ")
        });

        this.setGenericBlacklistKeywordsToggle();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .policy-form {
    height: calc(100% - 60px);
  }
  .remove-btn {
    width: 40px;
    padding: 0;
    border-color: $rd;
  }
  td,
  th {
    padding: 0 10px;
  }

  .rule-list ::v-deep .ant-form-explain {
    margin-bottom: -7px;
  }

  .rule-list {
    background-color: #f7f7f7;
    padding: 20px;

    .ant-form-item-label {
      label::after {
        content: '';
      }
    }

    td {
      padding: 5px;
    }
  }

  .smart-image-hash {
    .sih-checkbox {
      font-size: 0.8em !important;
    }

    .slider_title {
      font-weight: 600;
      font-size: 1.25em;
    }

    .ant-divider.ant-divider-vertical {
      /* Separator vertical line in the modal */
      width: 2px;
      background-color: rgb(211, 211, 211);
    }

    .grayscale {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      filter: grayscale(100%);
      opacity: 0.4;
    }
  }
</style>
